/* eslint-disable @typescript-eslint/camelcase */
import React from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  FormError,
  Button,
  Input,
  InputLabel as Label,
  IconLock,
} from '../../../..'
import {
  LoginFormErrors,
  useErrors,
  useLogin,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import { CTA, UnderlineCTA } from '../Styled'
import { SocialLogin } from '../SocialLogin'

export const LoginForm = ({
  handleClose,
  openForgotPassword,
}: {
  handleClose: () => void
  openForgotPassword: () => void
}) => {
  const [mutate, { isLoading, error }] = useLogin({ onSuccess: handleClose })
  const {
    errorMessages,
    globalValidations,
    password: passwordLabels,
    enter,
    emailAddress,
  } = useGlobalLabels()
  const apiErrors = useErrors<LoginFormErrors>(error, {
    invalid_client: errorMessages?.somethingWentWrong,
    invalid_credentials: errorMessages?.invalidCredentials,
    default: errorMessages?.somethingWentWrong,
  })

  const onSubmit = async ({ email, password }: any) => {
    mutate({ email, password })
  }

  const { handleSubmit, errors, control } = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
    mode: 'onChange',
  })

  const hasErrors = !Object.keys(errors).length

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Label>
        {emailAddress}
        <Controller
          control={control}
          name="email"
          rules={{
            required: globalValidations?.fieldIsRequired,
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: globalValidations?.invalidEmail,
            },
          }}
          as={<Input id="login-email" />}
        />
        <FormError errors={errors} fieldName="email" />
      </Label>
      <Label>
        {passwordLabels?.label}
        <Controller
          control={control}
          name="password"
          rules={{
            required: globalValidations?.fieldIsRequired,
          }}
          as={<Input id="login-pass" type="password" />}
        />
        <FormError errors={errors} fieldName="password" />
      </Label>
      <UnderlineCTA className="pt-1" onClick={openForgotPassword}>
        {`${passwordLabels?.forgottenPassword}?`}
      </UnderlineCTA>
      <CTA>
        <Button
          iconPosition="right"
          fullWidth
          type="submit"
          icon={<IconLock />}
          variant={hasErrors ? 'green' : 'disabled'}
          disabled={isLoading}
        >
          {enter}
        </Button>
      </CTA>
      <FormError errors={apiErrors} fieldName="invalid_client" />
      <FormError errors={apiErrors} fieldName="invalid_credentials" />
      <FormError errors={apiErrors} fieldName="default" />
      <SocialLogin handleClose={handleClose} />
    </form>
  )
}
